import { api_base_url, request } from '../utils';

const BASE = (api_base_url || '').replace(/\/+$/, '');

const normalizeInteraction = (interaction) => ({
  id: interaction?.Id,
  interaction: interaction?.Interaction,
  itemsAvailable: Number(interaction?.ItemsAvailable || 0),
  itemsSpend: Number(interaction?.ItemsSpend || 0),
  itemsToExchange: Number(interaction?.ItemsToExchange || 0),
  value: Number(interaction?.Value || 0),
});

export class ExchangeInteractionService {
  static ENDPOINT = `${BASE}/exchangeInteraction`;

  static async getAvailable() {
    const interactions = await request({
      url: `${this.ENDPOINT}/available`,
      headers: { Accept: 'application/json' },
    });
    if (!Array.isArray(interactions)) return interactions;
    return interactions.map(normalizeInteraction);
  }
}

export default ExchangeInteractionService;
